import { useEffect, useState } from "react";
import CustomText, { textStyles } from "../../components/CustomText";
import { useMediaQuery, Box, Skeleton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import leftcard1 from "../../assets/leftcard1.webp";
import leftcardes from "../../assets/leftcardes.webp";
import leftcardbottom from "../../assets/leftcardbottom.png";
import leftcardbottom2 from "../../assets/leftcardbottom2.png";
import arrow from "../../assets/arrow.png";
import frame2 from "../../assets/frame2.webp";
import frame3 from "../../assets/frame3.webp";
import lines from "../../assets/lines.png";
import emogies from "../../assets/emogies.png";
import pic1 from "../../assets/pic1.png";
import person1 from "../../assets/person1.png";
import person2 from "../../assets/person2.png";
import person4 from "../../assets/person4.png";
import Avatar from "@mui/material/Avatar";
import { useTranslation } from "react-i18next";

import { BASE_URL } from "../../components/BASE_URL";
const MainSection = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [loading, setLoading] = useState(true);
  const [mainTitle, setMainTitle] = useState("");
  const [mainDesc, setMainDesc] = useState("");

useEffect(() => {
  setLoading(true);

  fetch(`${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=About`)
    .then((res) => res.json())
    .then((json) => {
      const workforceSec = json?.data?.find((sec) => sec?.name === "About_Workforce");

      if (workforceSec?.items?.length) {
        const selected =
          i18n.language === "es"
            ? workforceSec.items.find((it) => it.idx === 1)
            : workforceSec.items.find((it) => it.idx === 0);

        if (selected) {
          setMainTitle(selected.title);
          setMainDesc(selected.description);
        }
      }
    })
    .catch((err) => {
      console.error("Error loading workforce section:", err);
    })
    .finally(() => setLoading(false));
}, [i18n.language]);



  const heroImageSrc = i18n.language === "es" ? leftcardes : leftcard1;
  const avatarSize = 40;
  const overlapMargin = -15;
  const groupGap = 10;
  const rowGap = 10;

  const groupsPerRow = [
    [[pic1, person1], [person1, person4, person2], [person1, pic1, person4]],
    [[pic1, person1], [person1, person4], [person1, pic1, person4]],
    [[person1, person4], [person1, pic1, person2], [person4, person2]],
  ];

  return (
    <>
      {/* Title + Description */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "#fff",
          height: "100%",
          px: 2,
          py: isMobile ? 6 : 11,
        }}
      >
        {loading ? (
          <Skeleton height={50} width="60%" />
        ) : (
          <CustomText
            style={{
              ...textStyles.h1,
              color: "#072533",
              marginBottom: isMobile ? "0rem" : "1rem",
              marginTop: "0rem",
              fontSize: isMobile ? "40px" : "50px",
            }}
          >
            {mainTitle}
          </CustomText>
        )}

        {loading ? (
          <>
            <Skeleton height={28} width="80%" />
            <Skeleton height={28} width="60%" />
          </>
        ) : (
          <CustomText
            style={{
              ...textStyles.body2,
              color: "#5E5C5C",
              maxWidth: "1175px",
              margin: "0 auto",
              marginTop: isMobile ? "20px" : "6px",
              fontSize: "21px",
            }}
          >
            {mainDesc}
          </CustomText>
        )}
      </Box>

      {/* Rest of your existing UI unchanged */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          justifyContent: "center",
          alignItems: "stretch",
          px: isMobile ? 2 : 15,
        }}
      >
   


      <Box
          sx={{
            // border:"1px solid red",
            flex: isMobile ? "1 1 20%" : '1 1 30%',
            minWidth: isMobile ? 160 : 250,
            //   border: '1px solid #ccc',
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            padding: 0,
            boxSizing: 'border-box',
            backgroundColor: '#fff',
            textAlign: 'center',
          }}
        >
          <img
            // src={leftcard1}
            src={heroImageSrc}
            alt="Card 1"
            style={{
              width: '100%',
              // height: 'auto',
              // maxHeight: '900px',
              // objectFit: 'contain',
              height: '400px',              // ✅ set desired height
              objectFit: 'cover',
              borderRadius: '8px',
            }}
          />
          <Box
            sx={{
              marginTop: 1,
              width: '100%',
              display: 'flex',
              flexWrap: isMobile ? "wrap" : "nowrap",
              justifyContent: isMobile ? 'center' : 'space-between',
              alignItems: "center",
              gap: 1,
            }}
          >
            <Box
              sx={{
                width: 180,
                height: 120,
                bgcolor: '#00293b',
                borderRadius: 3,
                boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                fontWeight: 600,
              }}
            >
              <CustomText
                style={{
                  ...textStyles.h3,
                  color: '#ffffff',
                  marginBottom: 0,
                  marginTop: 20,
                  fontSize: isMobile ? '20px' : '40px',
                  fontWeight: 600,
                }}
              >
                {t("main_section_left_card_count")}
              </CustomText>
              <CustomText
                style={{
                  ...textStyles.body2,
                  color: '#ffffff',
                  margin: 0,
                  fontSize: '22px',
                  textAlign: 'left',
                  lineHeight: 1.3,
                  marginTop: 10,
                }}
              >
                {t("main_section_left_card_label")}
              </CustomText>
            </Box>
            <Box
              sx={{
                width: 180,
                height: 120,
                borderRadius: 3,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                fontWeight: 600,
                marginTop: 5,
              }}
            >
              <CustomText
                style={{
                  ...textStyles.body2,
                  color: '#4B4B4B',
                  margin: 0,
                  fontSize: '22px',
                  textAlign: 'left',
                  lineHeight: 1.3,
                  marginTop: 10,
                  fontWeight: 600,
                }}
              >
                {t("main_section_left_card_label")}
              </CustomText>
              <img src={lines} style={{ marginTop: '10px' }} alt="lines" />
              <img src={emogies} style={{ marginLeft: '20px' }} alt="emogies" />
            </Box>
          </Box>
        </Box>


        {/* Middle Card */}
        <Box
          sx={{
            flex: "1 1 30%",
            minWidth: isMobile ? 200 : 250,
            borderRadius: 2,
            px: 2,
            boxSizing: "border-box",
            backgroundColor: "#fff",
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            overflow: "hidden",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <CustomText
              style={{
                ...textStyles.h3,
                color: "#003149",
                marginBottom: 0,
                marginTop: 0,
                fontSize: isMobile ? "18px" : "36px",
              }}
            >
              {t("main_section_middle_card_heading")}
            </CustomText>
            <img src={arrow} alt="arrow" style={{ height: 20 }} />
          </Box>
          <CustomText
            style={{
              ...textStyles.body2,
              color: "#5E5C5C",
              margin: 0,
              fontSize: "20px",
              textAlign: "left",
              lineHeight: 1.2,
              display: "-webkit-box",
              WebkitLineClamp: 4,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginTop: "15px",
            }}
          >
            {t("main_section_middle_card_description")}
          </CustomText>

          <div style={{ padding: 20 }}>
            {groupsPerRow.map((row, rowIndex) => (
              <div key={rowIndex} style={{ display: "flex", alignItems: "center", gap: groupGap, marginBottom: rowGap }}>
                {row.map((group, groupIndex) => (
                  <div key={groupIndex} style={{ display: "flex", alignItems: "center" }}>
                    {group.map((src, i) => (
                      <Avatar
                        key={i}
                        src={src}
                        alt={`avatar-r${rowIndex}-g${groupIndex}-i${i}`}
                        style={{
                          width: avatarSize,
                          height: avatarSize,
                          border: "2px solid white",
                          marginLeft: i === 0 ? 0 : overlapMargin,
                          zIndex: group.length - i,
                        }}
                      />
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
          <img
            src={frame2}
            alt="frame2"
            style={{
              display: "block",
              marginTop: "0px",
              width: "100%",
              height: "auto",
              maxHeight: "420px",
              objectFit: "contain",
              borderRadius: "8px",
            }}
          />
        </Box>

        {/* Right Card */}
        <Box
          sx={{
            flex: "1 1 30%",
            minWidth: 250,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            padding: 0,
            boxSizing: "border-box",
            backgroundColor: "#fff",
            textAlign: "center",
          }}
        >
          <img
            src={frame3}
            alt="frame3"
            style={{
              width: "100%",
              height: "580px",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        </Box>
      </Box>
    </>
  );
};

export default MainSection;



